import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { SEO } from '../../utils/seo';

interface Company {
  no: string;
  year: string;
  location: string;
  type: string;
  capital: string;
  description: string;
  price: string;
  status?: string;
  link?: string;
}

export default function CompanyList() {
  const [searchTerm, setSearchTerm] = useState('');

  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  const companies: Company[] = [
    {
      no: '805',
      year: '令和2年',
      location: '東京都',
      type: '株式会社',
      capital: '1500万円',
      description: 'MVNO事業。電気通信事業届出済み。総務省認可取得済みですぐに事業開始可能。大手キャリア回線を利用した格安SIMサービス提供。個人・法人向けに幅広く展開できる体制が整っています。自社ブランディング可能で料金プランも自由設計できます。',
      price: '1,280万円',
      link: '#'
    },
    {
      no: '801',
      year: '平成28年',
      location: '東京都',
      type: '株式会社',
      capital: '500万円',
      description: '令和6年3月まで営業実績あり。飲食業を中心とした事業展開。',
      price: '120万円',
      link: '#'
    },
    {
      no: '803',
      year: '令和元年',
      location: '大阪府',
      type: '株式会社',
      capital: '1200万円',
      description: 'MVNO事業。電気通信事業者として総務省届出済み。認可取得済みのため即座に通信サービス開始可能。法人向け通信サービスを中心に展開。データ通信・音声通話サービスを提供。独自の料金プランが特徴。自社ブランドでの展開が可能で、サービス内容も自由設計できます。',
      price: '1,050万円',
      link: '#'
    },
    {
      no: '798',
      year: '令和3年',
      location: '大阪府',
      type: '株式会社',
      capital: '300万円',
      description: '設立後2年間営業、以降休眠中。IT関連事業。',
      price: '55万円',
      link: '#'
    },
    {
      no: '802',
      year: '平成30年',
      location: '神奈川県',
      type: '株式会社',
      capital: '1000万円',
      description: 'MVNO事業。電気通信事業届出完了・認可取得済み。購入後すぐにMVNO事業を開始できます。データ通信専用SIMを中心としたサービス展開。個人・法人両方に対応可能な事業基盤を保有。自社ブランディングが可能で、プラン設計も自由に行えます。',
      price: '920万円',
      link: '#'
    },
    {
      no: '795',
      year: '平成18年',
      location: '神奈川県',
      type: '有限会社',
      capital: '300万円',
      description: '令和5年まで継続営業。不動産管理業。決算書完備。',
      price: '45万円',
      link: '#'
    },
    {
      no: '792',
      year: '平成12年',
      location: '愛知県',
      type: '有限会社',
      capital: '300万円',
      description: '5年前より休眠。建設業許可あり。休眠届提出済み。',
      price: '40万円',
      link: '#'
    },
    {
      no: '789',
      year: '平成25年',
      location: '福岡県',
      type: '株式会社',
      capital: '800万円',
      description: '直近まで営業実績あり。物流関連事業。',
      price: '商談中',
      status: 'negotiating',
      link: '#'
    },
    {
      no: '786',
      year: '令和元年',
      location: '千葉県',
      type: '株式会社',
      capital: '600万円',
      description: '設立後未稼働。資本金が大きめの法人をお探しの方に最適。',
      price: '65万円',
      link: '#'
    },
    {
      no: '783',
      year: '令和4年',
      location: '埼玉県',
      type: '株式会社',
      capital: '400万円',
      description: '1期のみ決算済み。以降休眠状態。',
      price: '50万円',
      link: '#'
    },
    {
      no: '780',
      year: '平成20年',
      location: '兵庫県',
      type: '有限会社',
      capital: '300万円',
      description: '長期休眠中。約10年間活動なし。',
      price: '商談中',
      status: 'negotiating',
      link: '#'
    },
    {
      no: '777',
      year: '平成17年',
      location: '静岡県',
      type: '有限会社',
      capital: '300万円',
      description: '令和4年まで営業。製造業関連。',
      price: '商談中',
      status: 'negotiating',
      link: '#'
    },
    {
      no: '774',
      year: '平成30年',
      location: '広島県',
      type: '株式会社',
      capital: '100万円',
      description: '直近決算完了。累積損失あり。',
      price: '商談中',
      status: 'negotiating',
      link: '#'
    },
    {
      no: '771',
      year: '令和5年',
      location: '宮城県',
      type: '株式会社',
      capital: '200万円',
      description: '設立後未稼働。新規事業をお考えの方におすすめ。',
      price: '45万円',
      link: '#'
    },
    {
      no: '768',
      year: '平成27年',
      location: '京都府',
      type: '株式会社',
      capital: '500万円',
      description: '古物商許可付き。令和5年まで営業実績あり。',
      price: '商談中',
      status: 'negotiating',
      link: '#'
    },
    {
      no: '765',
      year: '令和2年',
      location: '北海道',
      type: '株式会社',
      capital: '300万円',
      description: '初年度のみ営業。以降休眠中。',
      price: '50万円',
      link: '#'
    },
    {
      no: '762',
      year: '平成24年',
      location: '沖縄県',
      type: '株式会社',
      capital: '200万円',
      description: '約8年前より休眠。観光関連事業。',
      price: '45万円',
      link: '#'
    },
    {
      no: '759',
      year: '令和3年',
      location: '茨城県',
      type: '株式会社',
      capital: '400万円',
      description: '直近決算申告済み。コンサルティング業。',
      price: '60万円',
      link: '#'
    },
    {
      no: '756',
      year: '令和元年',
      location: '栃木県',
      type: '株式会社',
      capital: '50万円',
      description: '一般貨物自動車運送事業許可付き。昨年まで営業。',
      price: '85万円',
      link: '#'
    },
    {
      no: '753',
      year: '平成29年',
      location: '群馬県',
      type: '株式会社',
      capital: '700万円',
      description: '資本金が大きめ。卸売業での実績あり。',
      price: '75万円',
      link: '#'
    },
    {
      no: '750',
      year: '平成19年',
      location: '長野県',
      type: '有限会社',
      capital: '300万円',
      description: '長期間活動なし。約12年休眠。',
      price: '40万円',
      link: '#'
    },
    {
      no: '747',
      year: '令和4年',
      location: '岐阜県',
      type: '株式会社',
      capital: '100万円',
      description: '1期決算のみ。以降休眠状態。',
      price: '45万円',
      link: '#'
    },
    {
      no: '744',
      year: '昭和63年',
      location: '三重県',
      type: '株式会社',
      capital: '1000万円',
      description: '老舗法人。取引実績豊富。決算書完備。',
      price: '280万円',
      link: '#'
    }
  ];

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '売り会社一覧表',
    description: '休眠会社から許認可付き法人まで、豊富な在庫からお選びいただけます。MVNO事業、建設業許可、古物商許可など様々な案件を掲載。',
    url: `${siteUrl}/company-list`,
    mainEntity: {
      '@type': 'ItemList',
      numberOfItems: companies.length,
      itemListElement: companies.slice(0, 5).map((company, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        item: {
          '@type': 'Product',
          name: `${company.type} ${company.location} ${company.no}`,
          description: company.description,
          offers: {
            '@type': 'Offer',
            price: company.price.replace(/[^0-9]/g, ''),
            priceCurrency: 'JPY'
          }
        }
      }))
    }
  };

  const filteredCompanies = companies.filter(company =>
    company.no.includes(searchTerm) ||
    company.location.includes(searchTerm) ||
    company.type.includes(searchTerm) ||
    company.description.includes(searchTerm)
  );

  return (
    <div className="min-h-screen bg-gray-50">
      <SEO
        title="売り会社一覧表 | 休眠会社・稼働法人の譲渡案件 | 株式会社G11"
        description="休眠会社から許認可付き法人まで、豊富な在庫からお選びいただけます。MVNO事業、建設業許可、古物商許可など様々な案件を掲載。東京、大阪、神奈川など全国の法人売買案件をご紹介。"
        keywords="会社売買,休眠会社,稼働法人,法人譲渡,MVNO,建設業許可,古物商許可,有限会社,株式会社"
        jsonLd={jsonLd}
      />
      <Navbar />
      
      {/* Hero Section */}
      <div className="bg-gradient-to-br from-teal-600 to-teal-800 text-white py-12 md:py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-3xl md:text-5xl font-bold mb-3 md:mb-4">売り会社一覧表</h1>
            <p className="text-base md:text-xl text-teal-100 mb-6 md:mb-8 px-4">休眠会社から許認可付き法人まで、豊富な在庫からお選びいただけます</p>
            <div className="flex flex-col sm:flex-row justify-center items-center gap-3 md:gap-4 text-xs md:text-sm">
              <div className="flex items-center gap-2">
                <i className="ri-calendar-line text-xl md:text-2xl"></i>
                <span>最終更新: 11/20</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-building-line text-xl md:text-2xl"></i>
                <span>掲載件数: {companies.length}件</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Banner */}
      <div className="bg-amber-50 border-l-4 border-amber-500 py-3 md:py-4">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-start gap-2 md:gap-3">
            <i className="ri-information-line text-amber-600 text-xl md:text-2xl flex-shrink-0 mt-0.5 md:mt-1"></i>
            <div className="text-xs md:text-sm text-amber-800">
              <p className="font-semibold mb-1 md:mb-2">会社の売却希望のお客さまへ</p>
              <p>不要な法人をお持ちの方は、ぜひお問い合わせください。特に有限会社の買収希望が増えております。</p>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-12">
        
        {/* Search and Filter */}
        <div className="bg-white rounded-xl shadow-sm p-4 md:p-6 mb-6 md:mb-8">
          <div className="flex flex-col md:flex-row gap-3 md:gap-4">
            <div className="flex-1">
              <div className="relative">
                <i className="ri-search-line absolute left-3 md:left-4 top-1/2 -translate-y-1/2 text-gray-400 text-lg md:text-xl"></i>
                <input
                  type="text"
                  placeholder="NO.、所在地、法人形態、説明で検索..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="w-full pl-10 md:pl-12 pr-3 md:pr-4 py-2.5 md:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent outline-none text-sm md:text-base"
                />
              </div>
            </div>
            <button className="px-5 md:px-6 py-2.5 md:py-3 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors whitespace-nowrap flex items-center justify-center gap-2 text-sm md:text-base">
              <i className="ri-filter-3-line"></i>
              <span>詳細検索</span>
            </button>
          </div>
        </div>

        {/* Important Notes */}
        <div className="bg-blue-50 rounded-xl p-4 md:p-6 mb-6 md:mb-8">
          <h3 className="font-bold text-gray-900 mb-2 md:mb-3 flex items-center gap-2 text-sm md:text-base">
            <i className="ri-information-line text-blue-600 text-lg md:text-xl"></i>
            ご確認事項
          </h3>
          <ul className="space-y-2 text-xs md:text-sm text-gray-700">
            <li className="flex items-start gap-2">
              <i className="ri-checkbox-circle-fill text-blue-600 mt-0.5 flex-shrink-0"></i>
              <span>詳細欄はNO.をクリックしてご覧ください。</span>
            </li>
            <li className="flex items-start gap-2">
              <i className="ri-checkbox-circle-fill text-blue-600 mt-0.5 flex-shrink-0"></i>
              <span>記載していない詳細情報はお電話にてお問い合わせください。</span>
            </li>
            <li className="flex items-start gap-2">
              <i className="ri-checkbox-circle-fill text-blue-600 mt-0.5 flex-shrink-0"></i>
              <span>販売価格は登記費用別となっております。一般的な登記内容で+10~15万円ほどが目安です。</span>
            </li>
          </ul>
        </div>

        {/* Company List Table */}
        <div className="bg-white rounded-xl shadow-sm overflow-hidden mb-6 md:mb-8">
          <div className="overflow-x-auto">
            <table className="w-full min-w-[800px]">
              <thead className="bg-teal-600 text-white">
                <tr>
                  <th className="px-3 md:px-4 py-3 md:py-4 text-left text-xs md:text-sm font-semibold whitespace-nowrap">NO.</th>
                  <th className="px-3 md:px-4 py-3 md:py-4 text-left text-xs md:text-sm font-semibold whitespace-nowrap">設立年<br/>本店所在地</th>
                  <th className="px-3 md:px-4 py-3 md:py-4 text-left text-xs md:text-sm font-semibold whitespace-nowrap">法人形態<br/>資本金</th>
                  <th className="px-3 md:px-4 py-3 md:py-4 text-left text-xs md:text-sm font-semibold">主な事業目的・概要</th>
                  <th className="px-3 md:px-4 py-3 md:py-4 text-left text-xs md:text-sm font-semibold whitespace-nowrap">販売価格</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {filteredCompanies.map((company, index) => (
                  <tr key={index} className="hover:bg-gray-50 transition-colors">
                    <td className="px-3 md:px-4 py-3 md:py-4">
                      <a 
                        href={company.link || '#'} 
                        className="text-teal-600 hover:text-teal-800 font-semibold hover:underline text-xs md:text-sm"
                      >
                        {company.no}
                      </a>
                    </td>
                    <td className="px-3 md:px-4 py-3 md:py-4 text-xs md:text-sm">
                      <div className="whitespace-nowrap">{company.year}</div>
                      <div className="text-gray-600 whitespace-nowrap">{company.location}</div>
                    </td>
                    <td className="px-3 md:px-4 py-3 md:py-4 text-xs md:text-sm">
                      <div className="whitespace-nowrap font-medium">{company.type}</div>
                      <div className="text-gray-600 whitespace-nowrap">{company.capital}</div>
                    </td>
                    <td className="px-3 md:px-4 py-3 md:py-4 text-xs md:text-sm text-gray-700">
                      {company.description}
                    </td>
                    <td className="px-3 md:px-4 py-3 md:py-4 text-xs md:text-sm font-bold whitespace-nowrap">
                      {company.status === 'negotiating' ? (
                        <span className="text-orange-600">{company.price}</span>
                      ) : (
                        <span className="text-teal-700">{company.price}</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="md:hidden px-4 py-3 bg-gray-50 text-xs text-gray-600 text-center border-t border-gray-200">
            <i className="ri-arrow-left-right-line mr-1"></i>
            左右にスクロールできます
          </div>
        </div>

        {/* Update Information */}
        <div className="bg-white rounded-xl shadow-sm p-4 md:p-6 mb-8 md:mb-12">
          <h3 className="font-bold text-gray-900 mb-3 md:mb-4 flex items-center gap-2 text-sm md:text-base">
            <i className="ri-notification-line text-teal-600 text-lg md:text-xl"></i>
            更新情報
          </h3>
          <div className="space-y-3">
            <div className="flex gap-3 md:gap-4 text-xs md:text-sm">
              <span className="text-gray-500 whitespace-nowrap font-medium">2025/11/--</span>
              <p className="text-gray-700">法人の買収希望のお客様で、年内に手続き完了を希望するお客様は11月はやめのご連絡をおすすめしております。よろしくお願い申し上げます。</p>
            </div>
            <div className="flex gap-3 md:gap-4 text-xs md:text-sm">
              <span className="text-gray-500 whitespace-nowrap font-medium">2025/11/--</span>
              <p className="text-gray-700">WEB非公開の案件もございます。購入希望のお客様は希望条件や掲載している案件No.などをお電話でお伝えいただければ、現在の在庫の中で適したものをご紹介させていただきます。</p>
            </div>
            <div className="flex gap-3 md:gap-4 text-xs md:text-sm">
              <span className="text-gray-500 whitespace-nowrap font-medium">2025/11/20</span>
              <p className="text-gray-700">11月の入荷分の法人について、案件情報を掲載しております。買収をご検討のお客様はお問い合わせくださいませ。</p>
            </div>
            <div className="flex gap-3 md:gap-4 text-xs md:text-sm">
              <span className="text-gray-500 whitespace-nowrap font-medium">2025/10/30</span>
              <p className="text-gray-700">有限会社の買収のお申し出が増えております。不要な有限会社をお持ちのお客様はぜひお問い合わせください。</p>
            </div>
          </div>
        </div>

        {/* CTA Section */}
        <div className="bg-gradient-to-br from-teal-600 to-teal-800 rounded-xl md:rounded-2xl p-6 md:p-8 text-white text-center">
          <h3 className="text-xl md:text-2xl font-bold mb-3 md:mb-4">お探しの法人が見つかりませんか？</h3>
          <p className="text-sm md:text-base text-teal-100 mb-6 px-4">WEB非公開の案件も多数ございます。お気軽にお問い合わせください。</p>
          <div className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center">
            <a 
              href="tel:0120-000-0000" 
              className="px-6 md:px-8 py-3 md:py-4 bg-white text-teal-700 rounded-lg font-semibold hover:bg-gray-100 transition-colors flex items-center justify-center gap-2 text-sm md:text-base whitespace-nowrap"
            >
              <i className="ri-phone-line text-lg md:text-xl"></i>
              <span>お電話でのお問い合わせ</span>
            </a>
            <a 
              href="#contact" 
              className="px-6 md:px-8 py-3 md:py-4 bg-teal-500 text-white rounded-lg font-semibold hover:bg-teal-400 transition-colors flex items-center justify-center gap-2 text-sm md:text-base whitespace-nowrap"
            >
              <i className="ri-mail-line text-lg md:text-xl"></i>
              <span>メールでのお問い合わせ</span>
            </a>
          </div>
        </div>

      </div>

      <Footer />
    </div>
  );
}
